import React from 'react';
import clsx from 'clsx';
import styles from './DetailSection.module.css';

interface DetailSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const DetailSection: React.FC<DetailSectionProps> = ({ title, children, className }) => {
  return (
    <div className={clsx(styles.detailSection, className)}>
      {title && <h2>{title}</h2>}
      {children}
    </div>
  );
};

export default DetailSection;
